var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlockQuote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 96C512 91.594 508.406 88 504 88H8C3.594 88 0 91.594 0 96S3.594 104 8 104H504C508.406 104 512 100.406 512 96ZM504 248H136C131.594 248 128 251.594 128 256S131.594 264 136 264H504C508.406 264 512 260.406 512 256S508.406 248 504 248ZM504 408H136C131.594 408 128 411.594 128 416S131.594 424 136 424H504C508.406 424 512 420.406 512 416S508.406 408 504 408ZM24 224C19.594 224 16 227.594 16 232V440C16 444.406 19.594 448 24 448S32 444.406 32 440V232C32 227.594 28.406 224 24 224Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockQuote);
export default __webpack_public_path__ + "static/media/block-quote.73ef9e1881611cd845ab91da32378316.svg";
export { ForwardRef as ReactComponent };